import { FrontendFeatureFlagSaveItemType, FrontendFeatureFlagsListType } from 'src/pages/FrontendFeatureFlags';
import { httpGet, httpPost } from 'src/utils/http';

const path = '/frontendfeatureflag';

/** get list */
export const apiGetFrontendFeatureFlagList = (): Promise<FrontendFeatureFlagsListType> => httpGet(`${path}/flags`);

/** save list */
export const apiSaveFrontendFeatureFlagList = (list: FrontendFeatureFlagSaveItemType[]): Promise<void> =>
  httpPost(`${path}/save`, {
    Flags: list,
  });

/** add a flag */
export const apiAddFrontendFeatureFlag = (
  item: FrontendFeatureFlagSaveItemType
): Promise<FrontendFeatureFlagsListType> => httpPost(`${path}/addflag`, item);

/** remove a flag */
export const apiRemoveFrontendFeatureFlag = (
  name: FrontendFeatureFlagSaveItemType['Name']
): Promise<FrontendFeatureFlagsListType> => httpPost(`${path}/removeflag`, { Name: name });
